export default "__VITE_ASSET__Bsc7zG$F__"